import React from 'react'
import classes from './styles.module.scss'

export const Spinner = () => {
  return (
    <div className={classes.loader}  />
  )
}
